import React, { useMemo } from 'react';
import Helmet from 'react-helmet';
import { usePage } from '../contexts/pageContext';
import styled from 'styled-components/macro';
import ResultadosComposicion from '../containers/ResultadosComposicion';
import ResultadosVotosPartidos from '../containers/ResultadosVotosPartido';
import ResultadosInfoGeneral from '../containers/ResultadosInfoGeneral';
import ResultadosTerritorios from '../containers/ResultadosTerritorios';
import ResultadosVotosConsultas from '../containers/ResultadosVotosConsultas';
import { useEleccion, useSetEleccion } from '../contexts/eleccionContext';
import { responsive, eleccionesUnicandidato } from 'constantes';
import { useIsDesktop } from '../hooks/useMediaQuery';
import TablaTerritorios from '../containers/TablaTerritorios/TablaTerritorios';
import ResumenPorTerritorios from '../containers/Graficas/Territorios/ResumenTerritorios';
import PieResultados from '../containers/PieResultados';
import TablaPartidos from '../containers/TablaPartidos/TablaPartidos';
import LayoutResultados from '../components/LayoutResultados';
import ResultsGeneralData from '../components/ResultsGeneralData';
import { withRouter } from 'react-router-dom';
import { Location, SlicedPie } from '../assets/img';
import constantes from '../resources/constantes.json';
import BotonPartidos from '../components/svg/BotonPartidos';
import BotonTerritorios from '../components/svg/BotonTerritorios';
import GeneralPrint from '../print/reports/General';

const Resultados = ({ nomenclator, location }) => {
  const pageState = usePage();
  const elecOptions = useEleccion();
  const setElecOptions = useSetEleccion();
  const { urlInfo } = pageState;
  const { eleccion, idHistorico } = urlInfo;
  const esHistorico = idHistorico != null;
  const nomAmbitos = nomenclator.nomAmbitos[eleccion];
  const isDesktop = useIsDesktop();

  const ambito = useMemo(
    () => nomenclator.ambitos[(urlInfo?.eleccion)][(urlInfo?.id)],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [nomenclator, urlInfo?.eleccion, urlInfo?.id]
  );
  const pathname = location.pathname;
  const getSelectedSection = tab => {
    const tableOptions = elecOptions.tableOptions;
    const isUnicandidato = eleccionesUnicandidato.includes(
      elecOptions.idEleccion
    );
    switch (tab.id) {
      /* case 'composicion':
        return <ResultadosComposicion nomenclator={nomenclator} />; */
      case 'votosPartidos':
        return [
          <TablaPartidos
            camaraSeleccionada={elecOptions.selectedCamara}
            mostrarVotos={tableOptions.mostrarVotos}
            mostrarCargos={tableOptions.mostrarCargos}
            mostrarCandidatos={tableOptions.mostrarCandidatos}
            isUnicandidato={isUnicandidato}
            bogota={elecOptions.bogota}
          />,
          <PieResultados />,
        ];
      /* case 'votosPartidosConsultas':
        return <ResultadosVotosConsultas />; */
      case 'territorios':
        return [
          <TablaTerritorios
            ambito={ambito}
            camaraSeleccionada={elecOptions.selectedCamara}
          />,
          <ResumenPorTerritorios
            camaraSeleccionada={elecOptions.selectedCamara}
          />,
        ];
      /* case 'infoGeneral':
        return <ResultadosInfoGeneral />; */
      case 'votosPartidosCarousel':
        return [
          <TablaPartidos
            camaraSeleccionada={elecOptions.selectedCamara}
            mostrarVotos={tableOptions.mostrarVotos}
            mostrarCargos={tableOptions.mostrarCargos}
            mostrarCandidatos={tableOptions.mostrarCandidatos}
            isUnicandidato={isUnicandidato}
          />,
          <PieResultados />,
        ];
      default:
        return [<></>, <></>];
    }
  };

  if (!elecOptions) return null;
  const isCircuns = elecOptions?.selectedCamara?.cir;
  const idEleccion = Number(elecOptions?.idEleccion ?? '0');
  const displayTabs =
    (typeof isCircuns === 'string' || typeof isCircuns === 'number') &&
    Number(isCircuns) === 1 &&
    (idEleccion === 1 || idEleccion === 2);

  return (
    <Main esHistorico={esHistorico}>
      <Helmet>
        <title itemProp="name" lang="es">
          {nomAmbitos.n}
        </title>
      </Helmet>
      <GeneralPrint />
      <ContainerSection displayTabs={displayTabs}>
        <ResultsContainer>
          <ResultsGeneralData />
        </ResultsContainer>
        {displayTabs && (
          <TabsContainer>
            <IconContainer
              isActive={elecOptions?.selectedTab.id === 'votosPartidos'}
              onClick={() =>
                setElecOptions(prevElec => ({
                  ...prevElec,
                  selectedTab: {
                    id: 'votosPartidos',
                    title: 'Seleccionar votos a partidos',
                    element: props => <BotonPartidos {...props} />,
                  },
                }))
              }
            >
              <img
                style={{ width: isDesktop ? '30px' : '26px' }}
                alt="tabButton"
                src={SlicedPie}
              />
            </IconContainer>
            <IconContainer
              isActive={elecOptions?.selectedTab.id === 'territorios'}
              onClick={() =>
                setElecOptions(prevElec => ({
                  ...prevElec,
                  selectedTab: {
                    id: 'territorios',
                    title: 'Seleccionar territorios',
                    element: props => <BotonTerritorios {...props} />,
                  },
                }))
              }
            >
              <img
                style={{ width: isDesktop ? '30px' : '26px' }}
                alt="tabButton"
                src={Location}
              />
            </IconContainer>
          </TabsContainer>
        )}
        {elecOptions && (
          <LayoutResultados
            components={getSelectedSection(elecOptions.selectedTab)}
            keyForRerenderLeftSide={pathname}
          />
        )}
      </ContainerSection>
    </Main>
  );
};

const TabsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 16px;
  margin-bottom: 10px;
  @media (max-width: ${constantes.responsive.tablet}px) {
    margin-bottom: 20px;
    margin-top: 30px;
  }
  @media (max-width: ${constantes.responsive.mobile}px) {
    margin-bottom: 10px;
  }
`;
const IconContainer = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ isActive }) => (isActive ? '#E40424' : '#215ccc')};
  height: 4rem;
  width: 10.5rem;
  border-radius: 10rem;
  cursor: pointer;
  transition-duration: 250ms;
  @media (min-width: ${constantes.responsive.tablet + 1}px) {
    &:hover {
      transform: scale(1.05);
      cursor: pointer;
    }
  }
  @media (max-width: ${constantes.responsive.tablet}px) {
    height: 35px;
    width: 95px;
  }
`;

const Main = styled(({ esHistorico, ...rest }) => <div {...rest} />)`
  display: grid;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr;
  width: 100%;  
  margin: auto;
  margin-top: 0;
  margin-bottom: 0;
  @media (max-width: ${responsive.tablet}px) {
    // margin-top: ${({ esHistorico }) => (esHistorico ? '0px' : '124px')};
  }
  @media (max-width: ${responsive.mobile}px) {
    // margin-top: 153px;
  }
`;

const ContainerSection = styled.div`
  display: grid;
  grid-template-rows: ${({ displayTabs }) =>
    displayTabs ? 'auto 60px 80vh' : 'auto 80vh'};
  @media (max-width: ${responsive.tablet}px) {
    display: flex;
    flex-direction: column;
  }
`;

const ResultsContainer = styled.div`
  font-size: 10px;
  @media screen and (max-width: ${responsive.maxWidth.tablet}px) {
    display: none;
  }
`;

export default withRouter(Resultados);
